import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonButton,
    IonCheckbox,
    IonFab,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonAlert,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonSearchbar
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, arrowUp, closeOutline, add, person, barcode, business, locationOutline, trashOutline, createOutline, search } from 'ionicons/icons';
import ProductActions from '../../../actions/ProductActions';
import PosActions from '../../../actions/PosActions';

import { getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { DebounceInput } from 'react-debounce-input';

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;
}

interface IState {
    price_groups: any;
    bussines_locations: any;
    units_array: any;
    ModalUnitShow: any;
    fieldsUnit: any;
    location_prices: any;
    formErrors: any;
    datalogin: any;
    pages: any;
    total_rows: any;
    searchText: any;
    pageSize: any;
    current_count_data: any;
    unitsDB: any;
    data_pagin_unitsDB: any;
    alertDestroy: any;
}

class Unidades extends React.Component<IProps, IState> {
    ModalUnit: React.RefObject<HTMLIonModalElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.ModalUnit = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            price_groups: [],
            bussines_locations: [],
            units_array: [],
            ModalUnitShow: false,
            fieldsUnit: null,
            location_prices: [],
            formErrors: {},
            datalogin: props.datalogin,

            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            pageSize: props.pageSize,
            current_count_data: props.current_count_data,

            unitsDB: [],
            data_pagin_unitsDB: [],
            alertDestroy: false
        }
    }

    componentDidMount() {

        this.setState({
            ModalUnitShow: false,
            fieldsUnit: {
                id: null,
                location_prices: []
            },
            datalogin: getLoginApp(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            console.log("getDataPaginInit");
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_units',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_products/configuration'
        }, "api/get_list_units");
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            price_groups: nextProps.data.data_default && nextProps.data.data_default.price_groups_array ? nextProps.data.data_default.price_groups_array : [],
            bussines_locations: nextProps.data.data_default && nextProps.data.data_default.businessLocations ? nextProps.data.data_default.businessLocations : [],
            units_array: nextProps.data.data_default && nextProps.data.data_default.units_array ? nextProps.data.data_default.units_array : [],

            unitsDB: nextProps.data.unitsDB && nextProps.data.unitsDB ? nextProps.data.unitsDB : [],
            data_pagin_unitsDB: nextProps.data.data_pagin_unitsDB && nextProps.data.data_pagin_unitsDB ? nextProps.data.data_pagin_unitsDB : [],
            pages: nextProps.data.unitsDB && nextProps.data.unitsDB.pages ? nextProps.data.unitsDB.pages : 0,
            total_rows: nextProps.data.unitsDB && nextProps.data.unitsDB.total_rows ? nextProps.data.unitsDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_unitsDB ? nextProps.data.data_pagin_unitsDB.length : 0
        });

        if (nextProps.data.view_active == "dashboard_products/unidades") {
            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

    }

    openModalUnits(row: any) {
        let fieldsUnit = this.state.fieldsUnit;
        this.setState({
            ModalUnitShow: true,
            fieldsUnit: {
                id: null,
                location_prices: [],
                allow_decimal: null,
                define_base_unit: 0,
                base_unit_multiplier: '',
                actual_name: '',
                short_name: '',
                price: null,
                base_unit_id: null
            }
        });
    }

    dismissModalUnits() {
        this.setState({
            ModalUnitShow: false,
            fieldsUnit: {
                id: null,
                location_prices: [],
                allow_decimal: null,
                define_base_unit: 0,
                base_unit_multiplier: '',
                actual_name: '',
                short_name: '',
                price: null,
                base_unit_id: null
            }
        });
    }

    handleChangeUnit(event: any) {
        let fieldsUnit = this.state.fieldsUnit;
        fieldsUnit[event.target.name] = event.target.value;
        this.setState({
            fieldsUnit: fieldsUnit
        });
    }

    SaveDataPost() {
        let fieldsUnit = this.state.fieldsUnit;
        fieldsUnit['location_prices'] = this.state.location_prices;
        let error = false;
        let formErrors: any = {};
        if (this.state.fieldsUnit && this.state.fieldsUnit.actual_name == "") { formErrors['actual_name'] = "*Campo Requerido"; error = true };
        if (this.state.fieldsUnit && this.state.fieldsUnit.short_name == "") { formErrors['short_name'] = "*Campo Requerido"; error = true };
        if (this.state.fieldsUnit && (this.state.fieldsUnit.allow_decimal === null || this.state.fieldsUnit.allow_decimal === undefined)) { formErrors['allow_decimal'] = "*Campo Requerido"; error = true };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fieldsUnit.id) {
                this.props.post_({
                    typeOption: 'updateDataUnit',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fieldsUnit: this.state.fieldsUnit,
                    view_active: 'dashboard_products/unidades'
                }, "api/updateDataUnit");
            } else {
                this.props.post_({
                    typeOption: 'saveDataUnit',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fieldsUnit: this.state.fieldsUnit,
                    view_active: 'dashboard_products/unidades'
                }, "api/saveDataUnit");
            }
            this.setState({
                ModalUnitShow: false,
            });
        }


    }

    edit_unit(unit: any) {

        let fieldsUnit = {
            id: unit.id,
            location_prices: [],
            allow_decimal: unit.allow_decimal,
            define_base_unit: unit.base_unit_id && unit.base_unit_id != null ? 1 : 0,
            base_unit_multiplier: unit.base_unit_multiplier,
            actual_name: unit.actual_name,
            short_name: unit.short_name,
            price: unit.price,
            base_unit_id: unit.base_unit_id
        };

        if (unit.location_prices) {
            this.setState({
                ModalUnitShow: true,
                fieldsUnit: fieldsUnit,
                location_prices: JSON.parse(unit.location_prices)
            });
        } else {
            this.setState({
                ModalUnitShow: true,
                fieldsUnit: fieldsUnit
            });
        }


    }

    render_units(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><strong>Nombre:</strong> {row.actual_name}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><strong>Nombre Corto:</strong> {row.short_name}</label>
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small'
                            onClick={() => this.edit_unit(row)}
                        >
                            <div>
                                <IonIcon
                                    color="#ffffff"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'}
                            onClick={
                                e => this.setState({ alertDestroy: true, fieldsUnit: row })
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDataUnit',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fieldsUnit: this.state.fieldsUnit,
            view_active: 'dashboard_products/unidades'
        }, "api/destroyDataUnit");
        this.setState({
            alertDestroy: false
        });
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    render() {
        const {
            fieldsUnit,
            ModalUnitShow,
            price_groups,
            bussines_locations,
            location_prices,
            units_array,
            formErrors,
            data_pagin_unitsDB,
            unitsDB,
            total_rows,
            current_count_data,
            pages,
            alertDestroy,
            searchText

        } = this.state;

        if (bussines_locations && bussines_locations.length !== 0 && Object.keys(location_prices).length === 0) {
            // Recorrer bussines_locations y llenar location_prices[id] = null
            const temp_location_prices: Record<string, any> = {};
            bussines_locations.forEach((location: any) => {
                if (location && location.id != null) {
                    temp_location_prices[location.id] = null;
                }
            });
            this.setState({
                location_prices: temp_location_prices
            });
        }

        let data_render_units = [];
        if (data_pagin_unitsDB && data_pagin_unitsDB.length > 0) {
            data_render_units = [];
            data_render_units = data_pagin_unitsDB.map((val: any, key: any) =>
                this.render_units(val, key)
            );
        };
        return (
            <IonContent>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    //subHeader={'Verifique si conexión a internet.'}
                    message={'¿Desea eliminar la unidad?'}
                    buttons={[
                        /*{
                          text: 'Conservar',
                          handler: e => {
                            this.SendCon(e);
                          }
                        },*/
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonRow>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>
                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>
                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar por nombre'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                </IonRow>
                <IonRow>

                    <IonCol col-12 size='12' >
                        {data_render_units && data_render_units.length > 0 ? data_render_units : <IonCol col-12 size='12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                            <IonText color="medium" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: 'bold' }}>No hay valores disponibles</h5>
                            </IonText>
                        </IonCol>}
                    </IonCol>
                    <IonModal onDidDismiss={this.dismissModalUnits.bind(this)} isOpen={ModalUnitShow} ref={this.ModalUnit} trigger="open-modal">
                        <IonContent className="ion-padding">
                            <IonHeader>
                                <IonToolbar color="primary">
                                    <IonTitle>{fieldsUnit && fieldsUnit.id ? 'Editar Unidad' : 'Nueva Unidad'}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalUnits.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>
                            <IonRow>
                                <IonCol col-12 size='12'>
                                    <label>Nombre: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                        <input
                                            className='inputform'
                                            type="text"
                                            placeholder="Nombre de la Unidad"
                                            onChange={this.handleChangeUnit.bind(this)}
                                            value={(fieldsUnit && fieldsUnit.actual_name) ?? ""}
                                            name="actual_name" />
                                    </div>
                                    {formErrors && formErrors.actual_name && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.actual_name}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Nombre Corto: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                        <input
                                            className='inputform'
                                            type="text"
                                            placeholder="Nombre corto"
                                            onChange={this.handleChangeUnit.bind(this)}
                                            value={(fieldsUnit && fieldsUnit.short_name) ?? ""}
                                            name="short_name" />
                                    </div>
                                    {formErrors && formErrors.short_name && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.short_name}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Precio por Unidad: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChangeUnit({ target: { name: 'price', value: e.value } })}
                                        placeholder="Precio por Unidad"
                                        name='price'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={
                                            price_groups && price_groups.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={fieldsUnit && fieldsUnit.price ?
                                            price_groups && price_groups.length > 0 ?
                                                {
                                                    label: price_groups.filter((item: any) => item.id == fieldsUnit.price)[0].name, value: price_groups.filter((item: any) => item.id == fieldsUnit.price)[0].id
                                                }
                                                : null
                                            : null
                                        }
                                    />
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ textAlign: 'left', padding: '8px' }}>Sucursal</th>
                                                <th style={{ textAlign: 'left', padding: '8px' }}>Precio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bussines_locations && bussines_locations.map((location: any) =>
                                                location && location.id != null ? (
                                                    <tr key={location.id}>
                                                        <td style={{ padding: '8px' }}>{location.name}</td>
                                                        <td style={{ padding: '8px' }}>
                                                            <Select
                                                                className='inputformselect'
                                                                onChange={(e: any) => {
                                                                    // Actualizar el precio para la sucursal específica usando {id: valor} units
                                                                    this.setState({
                                                                        location_prices: {
                                                                            ...location_prices,
                                                                            [location.id]: e.value
                                                                        }
                                                                    });
                                                                }}
                                                                placeholder="Precio por Unidad"
                                                                name={`price_${location.id}`}
                                                                menuPortalTarget={document.querySelector('body')}
                                                                isSearchable={false}
                                                                options={
                                                                    price_groups && price_groups.map((value: any) => (
                                                                        { label: value.name, value: value.id }
                                                                    ))
                                                                }
                                                                styles={{
                                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                                }}
                                                                defaultValue={
                                                                    location_prices && location_prices[location.id] ?
                                                                        price_groups && price_groups.length > 0 ?
                                                                            {
                                                                                label: price_groups.filter((item: any) => item.id == location_prices[location.id])[0]?.name,
                                                                                value: price_groups.filter((item: any) => item.id == location_prices[location.id])[0]?.id
                                                                            }
                                                                            : null
                                                                        : null
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                ) : null
                                            )}
                                        </tbody>
                                    </table>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Decimales: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChangeUnit({ target: { name: 'allow_decimal', value: e.value } })}
                                        placeholder="Decimales"
                                        name='allow_decimal'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={
                                            [
                                                { label: 'Seleccione', value: null },
                                                { label: 'Si', value: 1 },
                                                { label: 'No', value: 0 }
                                            ]
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={
                                            fieldsUnit && fieldsUnit.allow_decimal != null ?
                                                [
                                                    { label: 'Seleccione', value: null },
                                                    { label: 'Si', value: 1 },
                                                    { label: 'No', value: 0 }
                                                ].filter((item: any) => item.value == fieldsUnit.allow_decimal)[0]
                                                : null
                                        }
                                    />
                                    {formErrors && formErrors.allow_decimal && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.allow_decimal}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox
                                        onIonChange={e => this.handleChangeUnit({ target: { name: 'define_base_unit', value: e.detail.checked ? 1 : 0 } })}
                                        checked={fieldsUnit && fieldsUnit.define_base_unit && fieldsUnit.define_base_unit == 1 ? true : false}
                                        labelPlacement="start" alignment="center">
                                        Sumar como múltiplo de la unidad base
                                    </IonCheckbox>
                                </IonCol>
                                {fieldsUnit && fieldsUnit.define_base_unit == 1 && (
                                    <IonCol col-12 size='12'>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr>
                                                    <th >1 Und	=</th>
                                                    <th style={{ width: '40%' }}>
                                                        <div className="inputWithIcon">
                                                            <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                                            <input
                                                                className='inputform'
                                                                type="text"
                                                                placeholder="Unidades"
                                                                onChange={this.handleChangeUnit.bind(this)}
                                                                value={(fieldsUnit && fieldsUnit.base_unit_multiplier) ?? ""}
                                                                name="base_unit_multiplier" />
                                                        </div>
                                                    </th>
                                                    <th >
                                                        <Select
                                                            className='inputformselect'
                                                            onChange={(e: any) => this.handleChangeUnit({ target: { name: 'base_unit_id', value: e.value } })}
                                                            placeholder="Base"
                                                            name='base_unit_id'
                                                            menuPortalTarget={document.querySelector('body')}
                                                            isSearchable={false}
                                                            options={
                                                                units_array && units_array.map((value: any) => (
                                                                    { label: value.name, value: value.id }
                                                                ))
                                                            }
                                                            styles={{
                                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                            }}
                                                            defaultValue={fieldsUnit && fieldsUnit.base_unit_id ?
                                                                units_array && units_array.length > 0 ?
                                                                    {
                                                                        label: units_array.filter((item: any) => item.id == fieldsUnit.base_unit_id)[0].name, value: units_array.filter((item: any) => item.id == fieldsUnit.base_unit_id)[0].id
                                                                    }
                                                                    : null
                                                                : null
                                                            }
                                                        />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                    </IonCol>
                                )}
                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={() => this.dismissModalUnits()}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',

                        }}
                    >
                        <IonFabButton onClick={(e) => this.openModalUnits(e)} color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonRow>
                <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                    onIonInfinite={(event) => {
                        this.getDataPaginInit();
                    }}
                >
                    <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>

                </IonInfiniteScroll>
            </IonContent>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        post_: PropTypes.func.isRequired,

    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ProductActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ProductActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ProductActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Unidades);
